var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { SectionNotificationType, SectionNotificationSize, } from './types';
import { SectionNotificationButton } from './Button/SectionNotificationButton';
import { SectionNotificationText } from './Text/SectionNotificationText';
import { SectionNotificationIcon } from './Icon/SectionNotificationIcon';
import { st, classes } from './SectionNotification.st.css';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { SectionNotificationProvider } from './SectionNotificationContext';
var uniqueId = require('lodash/uniqueId');
/** Section notification displays an important, succinct message, and provides actions for users to address and can not be dismissed.  */
var SectionNotification = /** @class */ (function (_super) {
    __extends(SectionNotification, _super);
    function SectionNotification(props) {
        var _this = _super.call(this, props) || this;
        _this.contentId = uniqueId('section-notification-contents-wrapper_');
        return _this;
    }
    SectionNotification.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, type = _a.type, className = _a.className, size = _a.size, ariaLabel = _a["aria-label"];
        var isError = type === SectionNotificationType.error;
        var isAlert = type === SectionNotificationType.alert;
        var isWired = type === SectionNotificationType.wired;
        var isSuccess = type === SectionNotificationType.success;
        var contents = [];
        var buttons = [];
        React.Children.forEach(children, function (child) {
            if (child && child.type === SectionNotificationButton) {
                buttons.push(child);
            }
            else {
                contents.push(child);
            }
        });
        var role = buttons.length
            ? 'group'
            : isError || isSuccess
                ? 'alert'
                : 'status';
        return (React.createElement(TPAComponentsConsumer, null, function (_a) {
            var rtl = _a.rtl;
            return (React.createElement("div", { className: st(classes.root, {
                    error: isError,
                    alert: isAlert,
                    rtl: rtl,
                    size: size,
                    wired: isWired,
                    success: isSuccess,
                }, className), role: role, "data-error": isError, "data-alert": isAlert, "data-wired": isWired, "data-success": isSuccess, "data-hook": _this.props['data-hook'], "aria-label": ariaLabel, "aria-describedby": _this.contentId },
                React.createElement("div", { className: classes.main },
                    React.createElement("div", { className: classes.contentsWrapper, id: _this.contentId }, contents),
                    buttons ? (React.createElement(SectionNotificationProvider, { value: { type: type } },
                        React.createElement("div", { className: classes.buttonsWrapper }, buttons))) : null)));
        }));
    };
    SectionNotification.displayName = 'SectionNotification';
    SectionNotification.defaultProps = {
        type: SectionNotificationType.default,
        size: SectionNotificationSize.regular,
    };
    SectionNotification.Text = SectionNotificationText;
    SectionNotification.Icon = SectionNotificationIcon;
    SectionNotification.Button = SectionNotificationButton;
    return SectionNotification;
}(React.Component));
export { SectionNotification };
//# sourceMappingURL=SectionNotification.js.map